import { __rest } from "tslib";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef, useState } from 'react';
import classNames from 'classnames';
import noop from 'lodash/fp/noop';
import { createButtonRipple } from '../../utils/buttonEffect';
const STYLES_MAP = {
    DEFAULT: 'default',
    PRIMARY: 'primary',
    SECONDARY: 'secondary',
    INFO: 'info',
    WARNING: 'warning',
    DANGER: 'danger',
    SUCCESS: 'success',
    MUTED: 'muted',
};
const VARIANTS_MAP = {
    VARIANT_LINK: 'link',
    VARIANT_LINK_INLINE: 'link-inline',
    VARIANT_OUTLINE: 'outline',
    VARIANT_ACTION: 'action',
};
const SIZES_MAP = {
    XS: 'xs',
    SM: 'sm',
    MD: 'md',
    LG: 'lg',
};
const Button = (props) => {
    const { active = false, disabled = false, asToggle = false, onClick = noop, bsStyle = 'default', bsSize, variant, iconOnly = false, iconName, multiline = false, block = false, className = '', noRippleEffect = false, children } = props, remainingProps = __rest(props, ["active", "disabled", "asToggle", "onClick", "bsStyle", "bsSize", "variant", "iconOnly", "iconName", "multiline", "block", "className", "noRippleEffect", "children"]);
    const [isToggled, setIsToggled] = useState(active);
    const btnRef = useRef(null);
    // Update internal toggle state when used as controlled component and outside toggle state changes
    const [previousActive, setPreviousActive] = useState(active);
    if (active !== previousActive) {
        setIsToggled(active);
        setPreviousActive(active);
    }
    const handleClick = (event) => {
        var _a;
        if (!noRippleEffect) {
            createButtonRipple(event.nativeEvent, event.currentTarget);
        }
        if (asToggle) {
            // Intercept click handler only for toggle button to update internal state and blur after click
            const newIsToggled = !isToggled;
            setIsToggled(newIsToggled);
            if (newIsToggled) {
                (_a = btnRef.current) === null || _a === void 0 ? void 0 : _a.blur();
            }
            onClick(newIsToggled);
        }
        else {
            onClick(event);
        }
    };
    const buttonClassNames = classNames('btn', `btn-${bsStyle}`, variant === Button.VARIANT_LINK && 'btn-link', variant === Button.VARIANT_LINK_INLINE && 'btn-link btn-link-inline', variant === Button.VARIANT_OUTLINE && 'btn-outline', variant === Button.VARIANT_ACTION && 'btn-action', bsSize && `btn-${bsSize}`, asToggle && 'btn-toggle', isToggled && 'active', iconOnly && 'btn-icon-only', disabled && 'disabled', multiline && 'btn-multiline', block && 'btn-block', 'btn-component', className);
    return (_jsxs("button", Object.assign({ ref: btnRef, type: 'button' }, remainingProps, { className: buttonClassNames, onClick: handleClick }, { children: [iconName && _jsx("span", { className: `rioglyph ${iconName}` }), children] })));
};
// Button styles
Button.DEFAULT = STYLES_MAP.DEFAULT;
Button.PRIMARY = STYLES_MAP.PRIMARY;
Button.SECONDARY = STYLES_MAP.SECONDARY;
Button.INFO = STYLES_MAP.INFO;
Button.WARNING = STYLES_MAP.WARNING;
Button.DANGER = STYLES_MAP.DANGER;
Button.SUCCESS = STYLES_MAP.SUCCESS;
Button.MUTED = STYLES_MAP.MUTED;
// Button Type
Button.VARIANT_LINK = VARIANTS_MAP.VARIANT_LINK;
Button.VARIANT_LINK_INLINE = VARIANTS_MAP.VARIANT_LINK_INLINE;
Button.VARIANT_OUTLINE = VARIANTS_MAP.VARIANT_OUTLINE;
Button.VARIANT_ACTION = VARIANTS_MAP.VARIANT_ACTION;
// Button Size
Button.XS = SIZES_MAP.XS;
Button.SM = SIZES_MAP.SM;
Button.MD = SIZES_MAP.MD;
Button.LG = SIZES_MAP.LG;
export default Button;
